// Third party
import React from 'react';
import moment from 'moment';

// Component
import { PrimaryButton } from '@/views/components/buttons';

// Utils
import { formatMessage, formatBytes } from '@/utils/i18n';
import { FILE_UPLOAD_SPECS } from '@/utils/constants';

type Props = {
  error?: string;
  file: any;
  replaceFile: any;
};
const FileUploadResult: React.FC<Props> = (props: Props) => {
  const { error, file, replaceFile } = props;

  const ErrorMessage = () => (
    <div className="message-container error">
      <div className="file-upload error">{formatMessage('Admin.DataUpload.FileTooLarge', { max_size: formatBytes(FILE_UPLOAD_SPECS.maxSize) })}</div>
    </div>
  );
  const SuccessMessage = () => (
    <div className="message-container success">
      <div className="file-upload success">{`${formatMessage('Admin.DataUpload.Uploaded')} ${moment().format('MMMM D, YYYY')}`}</div>
    </div>
  );

  const uploadedFileName = file?.url?.split('/').pop() || file?.name;

  return (
    <div className="modal-file-upload-result-container">
      <div className="file-details-container">
        <div className="file-upload-name-container">
          {error ? <i className="icon-exclamation" /> : <i className="icon-circle-checkmark" />}
          <span className="file-name">{uploadedFileName}</span>
        </div>
        <PrimaryButton onClick={replaceFile} className="data-upload-replace-btn" disabled={false}>
          <span className="">{formatMessage('Admin.DataUpload.Replace')}</span>
        </PrimaryButton>
      </div>
      {error ? <ErrorMessage /> : <SuccessMessage />}
    </div>
  );
};
export default FileUploadResult;
